import React, { useState } from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
import { TimeRatePipelineSettings } from '../../interfaces/Settings/TimeRatePipelineSettings';
import {
  isPositiveErrorMessage,
  max2DecimalErrorMessage,
  max2DecimalsRegexp,
  requiredErrorMessage,
} from '../../utilities/Constants';
import { isNumber } from '../../utilities/Misc';

interface SettingsNumberInputProps {
  currentState: TimeRatePipelineSettings;
  setter: (newState: TimeRatePipelineSettings) => void;
  fieldName: keyof TimeRatePipelineSettings;
  disabled: boolean;
  placeholder: string;
  minValue: number;
  maxValue: number;
}

const SettingsNumberInput = (props: SettingsNumberInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const [plainTextValue, setPlainTextValue] = useState('');

  const validators = [
    'isPositive',
    `matchRegexp:${max2DecimalsRegexp}`,
    `minNumber:${props.minValue}`,
    `maxNumber:${props.maxValue}`,
    'required',
  ];
  const errorMessages = [
    isPositiveErrorMessage,
    max2DecimalErrorMessage,
    `Minimum value: ${props.minValue}`,
    `Maximum value: ${props.maxValue}`,
    requiredErrorMessage,
  ];

  const handleChange = (e: any) => {
    props.setter({
      ...props.currentState,
      [props.fieldName]: parseFloat(e.target.value),
    });
    setPlainTextValue(e.target.value);
  };

  const getFormattedValue = (): string => {
    if (isFocused) {
      return plainTextValue;
    }
    const value = props.currentState[props.fieldName] as unknown as number;
    if (isNumber(value)) {
      return value.toFixed(2);
    }
    return '';
  };

  const handleFocus = () => {
    setIsFocused(true);
    setPlainTextValue(getFormattedValue());
  };

  return (
    <TextValidator
      label={props.placeholder}
      size='small'
      variant='outlined'
      type='number'
      value={getFormattedValue()}
      onBlur={() => setIsFocused(false)}
      onChange={handleChange}
      onFocus={handleFocus}
      style={{
        display: 'flex',
        flexGrow: 1,
      }}
      validators={validators}
      errorMessages={errorMessages}
      name={props.placeholder}
      disabled={props.disabled}
    />
  );
};

export default SettingsNumberInput;
